import { CatalogWalkThrough } from './catalog/CatalogWalkThrough';

export const GlobalModals = () => (
  <>
    <CatalogWalkThrough />
  </>
);
